/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

import {useBundle} from '@amzn/react-arb-tools';
import {HOMEPAGE_MESSAGE_BUNDLE_NAME} from 'src/constants';
import {t} from 'src/helpers';
import {Header} from 'src/theming/components/Header';
import {Screen} from 'src/theming/components/Screen';
import {Spinner} from 'src/theming/components/Spinner';
import * as styles from './styles/SubmissionLoadingScreen.module.scss';

export const SubmissionLoadingScreen = () => {
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);

  return (
    <Screen className={styles.container}>
      <Header
        title={t(bundle, 'submission_loading_title') ?? ''}
        description={t(bundle, 'submission_loading_description')}
      />
      <Spinner />
      {/* div for spacing purposes */}
      <div />
    </Screen>
  );
};
